export const detectClient = () => {   
  let userAgent = window.navigator.userAgent.toLowerCase();
  let browserType,
      deviceType,
      osType;

  if (userAgent.indexOf('trident') !== -1) {
    browserType = 'internet explorer';   
  } else if (userAgent.indexOf('firefox') !== -1) {
    browserType = 'firefox';    
  } else if (userAgent.indexOf('edge') !== -1) {
    browserType = 'edge';    
  } else if (userAgent.indexOf('chrome') !== -1) {
    browserType = 'chrome';  
  } else if (userAgent.indexOf('safari') !== -1) {
    browserType = 'safari';  
  } else {
    browserType = 'other';
  }
  
  if (userAgent.indexOf('android') !== -1) {
    deviceType = "android"
  } else if (userAgent.indexOf('ipad') !== -1) {
    deviceType = 'ipad';    
  } else if (userAgent.indexOf('iphone') !== -1) {
    deviceType = 'iphone';    
  } else {
    deviceType = 'other';  
  }

  if ((deviceType === 'ipad') || (deviceType === 'iphone')) {
    osType = userAgent.substring(userAgent.indexOf('('), userAgent.indexOf(')')+1);
  }

  return {
    browserType: browserType,
    deviceType: deviceType,
    osType: osType
  }
  
}